/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


jQuery(window).resize(function(){
 movePanels();
});

jQuery(document).ready(function(){
  
  $('#side-store-switch').on('change', function() { if( this.value == 'us')location.href = 'https://voyaskincare.com?loc=US'; });
  
  
  var intro = $('.ProductMeta__Description p:first');
console.log(intro);
    
    var menu = $(".ProductMeta__Description h3").map(function() {
    var $this = $(this);
		console.log( $this.text());
      console.log( $this.nextUntil("h3").html());
    return {
        title: $this.text(),
        content: $this.nextUntil("h3").html() /*.filter("p").map(function() { return $(this).text(); }).get()*/
    };
}).get();
    
    var containerStart = '<div class="container"><div class="row">';
    var containerEnd = '</div></div>';
    var output = '<div class="row"><div class="col-3"><ul>';
    
    var i = 0;
    menu.forEach(function(key, value){
                        
      console.log(key);
            console.log(value);
      var hidden = (i>0)?' hidden':'';
      var content = key.content;
      var contentJQ = $(content);
      console.log('_________0');
      var allImages = true;
      $('*', content).each(function(){
        if($(this).prop('nodeName')!='IMG'){allImages=false;}
      });
      var badgesClassStr = (allImages)?' badges':'';
      
      
            //console.log('_________1 '+areAllImgs);
      //console.log(contentJQ);
      $("#fs-product-tabs").append('<li data-tab-i="'+i+'"><span>'+key.title+'</span><div class="plus"><span></span><span></span></div></div><div class="mob-dropdown mob-dropdown-'+i+'"></div></li>');
      if(allImages) $("#fs-product-areas").append('<div class="product-panel product-panel-'+i+' '+hidden+'" ><div class="badges">'+key.content+'</div></div>');
      else $("#fs-product-areas").append('<div class="product-panel product-panel-'+i+' '+hidden+' '+badgesClassStr+'" >'+key.content+'</div>');
      i++;
      
            //console.log('_________2');
                  //console.log('---------');
            //console.log(value);
      output += '<li>'+key.title+'</li>';
    });
    
    
    $('#fs-product-tabs li').click(function(){
     
    var index =  $(this).attr('data-tab-i');
     
    	$('#fs-product-tabs li').removeClass('active');
	    $('.product-panel').hide();
    	$('.product-panel-'+index).fadeIn();
          //$('#fs-product-tabs li').hide();
      
    $(this).addClass('active');
      //alert($(this).attr('data-tab-i'));
  });
    
    //output += '</ul></div>';
    //output += '<div class="col-9">'+menu[0].content +'</div>';
    
    $('.ProductMeta__Description').html(intro);
        $('.ProductMeta__Description').css('opacity', '1');
  
  if(jQuery(window).width()<640){
    movePanelsToAccordion();
  }
});

var windowWidth = jQuery(window).width();

function movePanels(){
  var newWidth = jQuery(window).width();
  if(newWidth<992 && windowWidth>=992){
    movePanelsToAccordion();
  }
  if(windowWidth<992 && newWidth>=992){
    movePanelsToMain();
  }
  windowWidth = newWidth;
}

function movePanelsToAccordion(){
  var i=0;
  while(jQuery('.product-panel-'+i)[0]){
    console.log(i);
    jQuery('.product-panel-'+i).appendTo(jQuery('.mob-dropdown-'+i));
    i++;
  }
}

function movePanelsToMain(){
  var i=0;
  while(jQuery('.product-panel-'+i)[0]){
    console.log(i);
    jQuery('.product-panel-'+i).appendTo(jQuery('#fs-product-areas'));
    i++;
  }
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie(cookieName) {
  var user = getCookie(cookieName);
  if (user != "") {
    //alert("Welcome again " + user);
  } else {
    //user = prompt("Please enter your name:", "");
    if (user != "" && user != null) {
      setCookie(cookieName, user, 365);
    }
  }
}

function toggleHidden(id) {
  var attr = document.getElementById(id).attributes;
  
  if (attr['aria-hidden'].value == "true") {
    document.getElementById(id).setAttribute("aria-hidden", "false");
  } else {
    document.getElementById(id).setAttribute("aria-hidden", "true");
  }
  
  // Show aria-hidden value toggle. Codepen doesn't update HTML pane.
  document.getElementById('result').innerHTML = attr['aria-hidden'].value;
}